// extracted by mini-css-extract-plugin
module.exports = {"askSomethingElseButton":"ShaqbotSection_askSomethingElseButton__NtTbS"};